/* @deprecated Copied to app/modules/procurement/pages/vendors_management/vendor-profile/businessDetails/business-kyc-details.tsx. This file still serves the existing /UProcure routes. */
/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * @file business-kyc-details.tsx
 * @module app/modules/uProcure/vendors_management/vendor-profile/businessDetails/business-kyc-details
 * @description Page component for managing business KYC details in the vendors management section.
 *   Displays a list of business KYC details with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of business KYC details with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Card, Col } from 'react-bootstrap';
import { Profile } from '../../../../../../utils/string';
import { EditBusinessCertificate } from './edit-business-certificate';
import { EditBusinessDetails } from './edit-business-details';
import { ViewBusinessCertificate } from './view-business-certificate';
import { ViewBusinessDetails } from './view-business-details';
import { useEffect, useState } from 'react';
import { AllSeller } from '../../../../../../utils/constants';
import { EditBankDetails } from './edit-bank-details';
import { ViewBankDetails } from './view-bank-details';
const BusinessKycDetails = (props: any) => {
    const [data, setData] = useState(props);
    return (
        <>
            <Col lg={12}>
                <Card className="border p-0 mb-5 mb-xl-10">
                    <Card.Header className="bg-light">
                        <Card.Title>
                            <h3 className="fs-22 fw-700 m-0">{Profile.businessDetails}</h3>
                        </Card.Title>
                    </Card.Header>
                    {props.show ? (
                        <EditBusinessDetails
                            handleAddressChange={props.handleAddressChange}
                            editData={props.editData}
                            profileData={props.profileData}
                            category={props.category}
                            businessTypes={props.businessTypes}
                            onDetailsChange={(name: string, value: string) => {
                                props.onDetailsChange(name, value);
                            }}
                            onCategorySelect={(event: any, action: any) => {
                                props.onCategorySelect(event, action);
                            }}
                            onBusinessTypesSelect={(event: any) => {
                                props.onBusinessTypesSelect(event);
                            }}
                            currentIndex={props.currentIndex}
                            moduleName={AllSeller}
                            businessCertificate={props.businessCertificate}
                        />
                    ) : props.profileData ? (
                        <ViewBusinessDetails profileData={props.profileData} />
                    ) : (
                        <></>
                    )}
                </Card>
                {props.show ? (
                    <Card className="border p-0 mb-5 mb-xl-10">
                        <Card.Header className="bg-light">
                            <Card.Title>
                                <h3 className="fs-22 fw-700 m-0">{Profile.bankDetails}</h3>
                            </Card.Title>
                        </Card.Header>
                        <EditBankDetails
                            editData={props.editData}
                            hanldeAddMore={props.hanldeAddMore}
                            hanldeRemove={props.hanldeRemove}
                            hanldeBankDetails={props.hanldeBankDetails}
                        />
                    </Card>
                ) : (
                    <Card className="border p-0 mb-5 mb-xl-10">
                        <Card.Header className="bg-light">
                            <Card.Title>
                                <h3 className="fs-22 fw-700 m-0">{Profile.bankDetails}</h3>
                            </Card.Title>
                        </Card.Header>
                        {props?.profileData?.business?.banks?.length > 0 ? (
                            <ViewBankDetails profileData={props.profileData} />
                        ) : (
                            <div className="card-body p-9">
                                <span className="fs-16 fw-600 text-muted">No bank details</span>
                            </div>
                        )}
                    </Card>
                )}
                {props.show ? (
                    <Card className="border p-0 ">
                        <Card.Header className="bg-light">
                            <Card.Title>
                                <h3 className="fs-22 fw-700 m-0">
                                    {Profile.businessCertificate}
                                </h3>
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <EditBusinessCertificate
                                editData={props.editData}
                                profileData={props.profileData}
                                businessCertificate={props.businessCertificate}
                                onCertificateChange={props.onCertificateChange}
                                onPendingCertificateChange={props.onPendingCertificateChange}
                                handleShowExpiry={(index: number) => {
                                    props.handleShowExpiry(index);
                                }}
                                currentIndex={props.currentIndex}
                                handleHideExpiry={props.handleHideExpiry}
                                handleExpirySelect={(value: string, index: number): void =>
                                    props.handleExpirySelect(value, index)
                                }
                                showExpiry={props.showExpiry}
                            />
                        </Card.Body>
                    </Card>
                ) : props.profileData && props?.editData?.business?.certificates?.length > 0 ? (
                    <Card className="border p-0 ">
                        <Card.Header className="bg-light">
                            <Card.Title>
                                <h3 className="fs-22 fw-700 m-0">
                                    {Profile.businessCertificate}
                                </h3>
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <ViewBusinessCertificate profileData={props.profileData} />
                        </Card.Body>
                    </Card>
                ) : (
                    <></>
                )}
            </Col>
        </>
    );
};
export default BusinessKycDetails;
